"use strict";

exports.__esModule = true;
exports["default"] = void 0;
/* Captured From PROD at http://localhost:3000/en/campaigns/into-the-unknown */
var DEFAULT_PROPS = {
  id: 'language-masters_en_1549537637499',
  resourceType: 'CarouselImage_1_0_0',
  lastModified: '1549537637499',
  titleAndText: null,
  staticImage: null,
  items: [{
    titleAndText: {
      title: 'what is this?',
      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
      __typename: 'TitleAndText'
    },
    image: {
      altText: 'carousel image',
      image: 'https://www.dev.mipulse.co/content/dam/mitsubishi-motors/images/cars/i-miev/2019/primary/exterior/P26_0_19TQ-1-Side.png',
      __typename: 'Image'
    },
    backgroundImage: null,
    content: null,
    valueSection: null,
    __typename: 'CarouselItem'
  }, {
    titleAndText: {
      title: 'xxxx',
      text: null,
      __typename: 'TitleAndText'
    },
    image: {
      altText: 'capsule image',
      image: 'https://www.dev.mipulse.co/content/dam/mitsubishi-motors/images/cars/i-miev/2019/primary/exterior/P26_45_19TQ-1-Front.png',
      __typename: 'Image'
    },
    backgroundImage: null,
    content: null,
    valueSection: null,
    __typename: 'CarouselItem'
  }, {
    titleAndText: {
      title: 'xxxx',
      text: null,
      __typename: 'TitleAndText'
    },
    image: {
      altText: 'carousel image',
      image: 'https://www.dev.mipulse.co/content/dam/mitsubishi-motors/images/cars/i-miev/2019/primary/exterior/P26_45_19TQ-1-Front-L.png',
      __typename: 'Image'
    },
    backgroundImage: null,
    content: null,
    valueSection: null,
    __typename: 'CarouselItem'
  }, {
    titleAndText: {
      title: 'xxx',
      text: null,
      __typename: 'TitleAndText'
    },
    image: {
      altText: 'image',
      image: 'https://www.dev.mipulse.co/content/dam/mitsubishi-motors/images/cars/i-miev/2019/primary/exterior/P26_225_19TQ-1-Rear.png',
      __typename: 'Image'
    },
    backgroundImage: null,
    content: null,
    valueSection: null,
    __typename: 'CarouselItem'
  }],
  __typename: 'Carousel'
};
var _default = DEFAULT_PROPS;
exports["default"] = _default;